t = require('views/internal/teacup-with-helpers')('attachment_thumb_processing')

module.exports = t.renderable ->
  t.div '.attachment-thumbnail.attachment-thumbnail-processing.js-attachment-thumb-processing', ->
    t.format 'processing-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/attachment_thumb_processing.coffee